/**
 * Funder budget categories. A grant total is not a budget: funders approve
 * lines and read reports line by line. These are the categories every
 * budget line rolls up to, shared by the budget-vs-actual view and the
 * accounting mapping so a GL account can be pointed at one of them.
 */
export const BUDGET_CATEGORIES = [
    'Personnel',
    'Programme activities',
    'Equipment and assets',
    'Travel and subsistence',
    'Monitoring and evaluation',
    'Administration',
    'Other',
];
/** Categories that count toward a funder's administration / indirect-cost cap. */
export const ADMIN_BUDGET_CATEGORIES = ['Administration'];
export function isBudgetCategory(value) {
    return BUDGET_CATEGORIES.includes(value);
}
